// src/pages/auth/Login.jsx
import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import { toast } from "react-toastify";
import AuthLayout from "../../components/AuthLayout";
import { Box, Button, TextField, Typography, Link, InputAdornment, IconButton } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { AUTH_DISABLED } from "../../config/authConfig";
import API_BASE_URL from "../../config/api";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    /* ===============================
       AUTH DISABLED (UI ONLY)
    ================================ */
    if (AUTH_DISABLED) {
      localStorage.setItem("token", "ui-demo-token");
      localStorage.setItem("role", "Admin");
      localStorage.setItem("fullName", "Demo User");

      toast.success("Welcome, Demo User!");
      navigate("/dashboard");
      return;
    }

    /* ===============================
       REAL AUTH (KEPT FOR LATER)
    ================================ */
    setLoading(true);
    try {
      const res = await axios.post(`${API_BASE_URL}/api/users/login`, {
        username,
        password,
      });

      const { token, role, fullName } = res.data;

      localStorage.setItem("token", token);
      localStorage.setItem("role", role);
      localStorage.setItem("fullName", fullName || "User");

      toast.success(`Welcome back, ${fullName || "User"}!`);
      navigate("/dashboard");
    } catch (err) {
      const errorMessage = err.response?.data?.message || "Login failed";
      toast.error(errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography
          textAlign="center"
          fontWeight={600}
          color="white"
          sx={{
            fontSize: {
              xs: "1.12rem",
              sm: "1.5rem",
              md: "1.75rem",
              lg: "2rem",
            },
          }}
        >
          Login to your Account
        </Typography>

        <TextField
          label="Username or Email"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          fullWidth
          autoComplete="off"
          sx={{ width: '100%' }}
        />

        <TextField
          label="Password"
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          fullWidth
          autoComplete="new-password"
          sx={{ width: '100%' }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword((s) => !s)}
                  edge="end"
                  tabIndex={-1}
                >
                  {showPassword ? <VisibilityOff sx={{ color: '#fff' }} /> : <Visibility sx={{ color: '#fff' }} />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />



        <Button variant="contained" type="submit" size="large" disabled={loading}>
          {loading ? "Logging in..." : "Login"}
        </Button>

        <Box sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
          <Link
            component={RouterLink}
            to="/forgot-password"
            sx={{
              fontSize: {
                xs: "0.75rem",
                sm: "0.85rem",
                md: "0.9rem",
              },
            }}
          >
            Forgot password?
          </Link>

        </Box>
      </Box>
    </AuthLayout>
  );
}
